import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import NodeWrapper from "./NodeWrapper";
import useHandleConnected from "./useHandleConnected";
import { Category } from "@mui/icons-material";

/**
 * Text Classifier Node — Classificar texto em categorias usando IA.
 *
 * data.provider: "openai" | "gemini" — provedor de IA
 * data.categories: array de { label: string, description: string }
 * data.inputVar: string — variavel com o texto a classificar
 * data.outputVar: string — variavel para a categoria resultante
 * data.fallbackCategory: string — categoria padrao se nenhuma der match
 *
 * Saidas: um handle por categoria + handle "fallback"
 */
const TextClassifierNode = memo(({ id, data, isConnectable, selected }) => {
  const getHandleClass = useHandleConnected(id);
  const categories = data?.categories || [
    { label: "Financeiro" },
    { label: "Suporte" },
    { label: "Comercial" },
  ];
  const provider = data?.provider || "openai";

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<Category />}
      title="Classificador"
      color="#7B1FA2"
      bgColor="#F3E5F5"
      noSource
      isConnectable={isConnectable}
      selected={selected}
      minWidth={220}
    >
      <div style={{
        background: "#fff", border: "1px solid #e0e0e0",
        borderRadius: 6, padding: "5px 10px", fontSize: 10, color: "#999",
      }}>
        IA: {provider.toUpperCase()} • {categories.length} categorias
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 4, marginTop: 8 }}>
        {categories.map((cat, i) => (
          <div key={i} style={{
            display: "flex", alignItems: "center", justifyContent: "flex-end",
            gap: 6, position: "relative", paddingRight: 4,
          }}>
            <span style={{
              fontSize: 10, fontWeight: 700, color: "#fff",
              background: "#7B1FA2", borderRadius: 4, padding: "2px 10px",
              maxWidth: 140, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
            }}>{cat.label || `Cat ${i + 1}`}</span>
            <Handle type="source" position={Position.Right} id={`cat_${i}`}
              className={getHandleClass("source", `cat_${i}`)}
              style={{
                position: "absolute", top: "50%", right: -13,
                transform: "translateY(-50%)",
                cursor: "crosshair",
              }} isConnectable={isConnectable} />
          </div>
        ))}
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "flex-end",
          gap: 6, position: "relative", paddingRight: 4,
        }}>
          <span style={{
            fontSize: 10, fontWeight: 700, color: "#fff",
            background: "#9e9e9e", borderRadius: 4, padding: "2px 10px",
          }}>OUTROS</span>
          <Handle type="source" position={Position.Right} id="fallback"
            className={getHandleClass("source", "fallback")}
            style={{
              position: "absolute", top: "50%", right: -13,
              transform: "translateY(-50%)",
              cursor: "crosshair",
            }} isConnectable={isConnectable} />
        </div>
      </div>
    </NodeWrapper>
  );
});

TextClassifierNode.displayName = "TextClassifierNode";
export default TextClassifierNode;
